import EasyEquipment from "@/models/server/EasyEquipment";

export default class ConstructionSiteItemsGrouped {
    public name: string = "";

    public items: EasyEquipment[] = [];
}